import { Type } from '@angular/core';
import { AutomationRuleType } from '@kinet-open-network/shared/data-access/model';
import { RuleComponent } from './abstract-rule.component';
import { InvoiceDeliveryTypeRuleComponent } from './invoice-delivery-type-rule.component';
import { OverdueInvoiceAmountRuleComponent } from './overdue-invoice-date-amount.component';
import { OverdueInvoiceDateRuleComponent } from './overdue-invoice-date-rule.component';
import { TagRuleComponent } from './tag-rule.component';

const RULES_MAP: Partial<Record<AutomationRuleType, Type<RuleComponent>>> = {
  tag: TagRuleComponent,
  overdue_invoice: OverdueInvoiceDateRuleComponent,
  overdue_invoice_amount: OverdueInvoiceAmountRuleComponent,
  invoice_delivery_type: InvoiceDeliveryTypeRuleComponent,
};

export default RULES_MAP;
